// eslint-disable-next-line @typescript-eslint/no-explicit-any

export let OAuthProvider = /*#__PURE__*/function (OAuthProvider) {
  OAuthProvider["Intuit"] = "intuit";
  OAuthProvider["Google"] = "google";
  return OAuthProvider;
}({});
export let BusinessType = /*#__PURE__*/function (BusinessType) {
  BusinessType["Accounting"] = "accounting";
  BusinessType["Bookkeeping"] = "bookkeeping";
  BusinessType["TaxRepresentation"] = "tax";
  BusinessType["TaxPreparation"] = "tax_preparation";
  BusinessType["TaxResolution"] = "tax_resolution";
  BusinessType["Marketing"] = "marketing";
  BusinessType["Other"] = "other";
  return BusinessType;
}({});
export let PayoutBankAccountType = /*#__PURE__*/function (PayoutBankAccountType) {
  PayoutBankAccountType["Connected"] = "connected";
  PayoutBankAccountType["NotConnected"] = "notConnected";
  return PayoutBankAccountType;
}({});
export const isBankAccountConnected = account => !!account && account.type === PayoutBankAccountType.Connected;
export let KycCompletionStatus = /*#__PURE__*/function (KycCompletionStatus) {
  KycCompletionStatus["InitialIncomplete"] = "initialIncomplete";
  KycCompletionStatus["AwaitingCompletion"] = "awaitingCompletion";
  KycCompletionStatus["Completed"] = "completed";
  KycCompletionStatus["Incomplete"] = "incomplete";
  KycCompletionStatus["CompletedWithFutureRequirements"] = "completedWithFutureRequirements";
  return KycCompletionStatus;
}({});
export let UserRole = /*#__PURE__*/function (UserRole) {
  UserRole["Member"] = "member";
  UserRole["Admin"] = "admin";
  UserRole["Owner"] = "owner";
  UserRole["Accountant"] = "accountant";
  UserRole["AnchorAdmin"] = "anchorAdmin";
  UserRole["Reviewer"] = "reviewer";
  return UserRole;
}({});